import { MenuItem } from "./MenuData";

export const auth_menu_data: MenuItem[] = [
  {
    id: 1,
    page: "nav_2",
    has_dropdown: false,
    title: "Dashboard",
    link: "/dashboard",
  },
  {
    id: 2,
    page: "nav_2",
    has_dropdown: false,
    // title: "Wallet",
    // link: "/dashboard/wallet",
    title: "Sell Crypto",
    link: "/dashboard/trade",
  },
  // {
  //   id: 3,
  //   page: "nav_2",
  //   has_dropdown: false,
  //   title: "Transactions",
  //   link: "/dashboard/transaction",
  // },
  // {
  //   id: 4,
  //   page: "nav_2",
  //   has_dropdown: false,
  //   title: "Wallet",
  //   link: "/dashboard/wallet",
  //   // sub_menus: [
  //   //   { link: "#", title: "Buy Crypto", commingSoon: true },
  //   //   { link: "/dashboard/trade", title: "Sell Crypto" },
  //   //   // { link: "/dashboard/trade-history", title: "Trade History" },
  //   // ],
  // },
  // {
  //   id: 5,
  //   page: "nav_2",
  //   has_dropdown: true,
  //   title: "Account",
  //   link: "/dashboard/account/profile",
  //   sub_menus: [
  //     { link: "/dashboard/account/profile", title: "Profile" },
  //     { link: "/dashboard/account/bank", title: "Bank" },
  //     // { link: "/dashboard/account/support", title: "Support" },
  //     // { link: "/dashboard/account/limits", title: "Limits" },
  //     // { link: "/dashboard/account/security", title: "Security Settings" },
  //   ],
  // },
];
